import { extractUrlFromIconJsonLd } from '@atlaskit/link-extractors';
export var extractTaskType = function extractTaskType(jsonLd) {
  // TODO: Remove once Jira migrate to the correct type.
  var taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
  if (taskType) {
    if (typeof taskType === 'string') {
      return {
        id: taskType
      };
    } else if (taskType['@type'] === 'Link') {
      return {
        id: taskType.href
      };
    } else {
      return {
        id: taskType['@id'],
        name: taskType.name,
        icon: taskType.icon && extractUrlFromIconJsonLd(taskType.icon)
      };
    }
  }
};